var _symbol, _symbol2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "up-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.68,19.68a1,1,0,0,1-.71-.29l-9.09-9.1c-1.42-1.41-2.44-2.44-2.94-2.44s-1.51,1-2.93,       2.44l-9.09,9.1A1,1,0,0,1,2.5,18l9.1-9.09c4-4,4.67-4,8.69,0L29.39,18a1,1,0,0,1,0,1.42A1,1,0,0,1,28.68,19.68Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "down-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.68,19.68a1,1,0,0,1-.71-.29l-9.09-9.1c-1.42-1.41-2.44-2.44-2.94-2.44s-1.51,1-2.93,       2.44l-9.09,9.1A1,1,0,0,1,2.5,18l9.1-9.09c4-4,4.67-4,8.69,0L29.39,18a1,1,0,0,1,0,1.42A1,1,0,0,1,28.68,19.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.e70ca776d82b55924765e4b01c30a919.svg";
export { ForwardRef as ReactComponent };